/* global PUBLIC_PATH */
import { h, Component } from 'preact';
import { Router } from 'preact-router';

import Header from './header';
import Home from '../routes/home';
import Bunnymark from '../routes/bunnymark';

const Stats = ({ title, value }) => (
	<span>
		<span class="title">{title}: </span>
		{value}
		&nbsp;
	</span>
);

const Footer = ({ fps, ms, stats }) => (
	<footer class="footer">
		<Stats title="fps" value={Math.round(fps)} />
		<Stats title="ms" value={ms.toFixed(1)} />
		{(stats || []).map(({ title, value }) => (
			<Stats title={title} value={value} />
		))}
	</footer>
);

const getTime = () => (performance || Date).now();

// <Stat title="ms" value={`${ms.toFixed(1)} (${(ms * 6) | 0}%)`} />

export default class App extends Component {
	state = {
		loop: null,
		fps: 0,
		ms: 0,
		stats: null
	};

	handleRoute = e => {
		// console.log('route:', e.url);
		this.currentUrl = e.url;
		this.setState({
			loop: null,
			fps: 0,
			ms: 0,
			stats: null
		});
	};

	start = loop => {
		this.setState({ loop });
	};

	loop = () => {
		if (this.state.loop) {
			const begin = getTime();
			const delta = begin - this.prevBegin || begin;

			const stats = this.state.loop(delta);

			const k = 0.05;
			const ms = (1 - k) * this.state.ms + k * (getTime() - begin);
			const fps = (1 - k) * this.state.fps + k * (1000 / delta);
			this.setState({ fps, ms, stats });

			this.prevBegin = begin;
		}

		requestAnimationFrame(this.loop);
	};

	componentDidMount() {
		this.loop();
	}

	render() {
		const { fps, ms, stats, loop } = this.state;
		return (
			<div id="app">
				<Header />
				<Router onChange={this.handleRoute}>
					<Home path={PUBLIC_PATH} start={this.start} />
					<Bunnymark
						path={`${PUBLIC_PATH}bunnymark`}
						start={this.start}
					/>
				</Router>
				{loop && <Footer fps={fps} ms={ms} stats={stats} />}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js